module.exports = __webpack_public_path__ + "img/attachment.8fc13f8b.svg";